const CHANNELS = {
  chat: {
    id: 'chat',
    label: 'Chat',
    canTransfer: true,
  },
  form: {
    id: 'form',
    label: 'Form',
    canTransfer: true,
  },
  community: {
    id: 'community',
  },
  generator: {
    id: 'generator',
    label: 'Seed',
  },
  mail: {
    id: 'mail',
  },
  facebook: {
    id: 'facebook',
  },
  salesforce: {
    id: 'salesforce',
  },
};

// eslint-disable-next-line import/prefer-default-export
export { CHANNELS };
